export const obtenerSeccionUrl = ({path, index = 0}) => {

    let arr = path.split('/')
    return arr[index]
}